export enum Direction {
  forward = 'forward',
  backward = 'backward'
}

export enum SizeStrategy {
  Average = 'average',
  Constant = 'constant',
  Frequent = 'frequent'
}
